<!-- rota: /cari/kurgirisi  (name: kurgirisi) -->
<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Exchange-Entry')}}</v-toolbar-title>
              <v-spacer></v-spacer>


            </v-toolbar>
          </v-flex>


          <v-container fluid>

            <v-form ref="formkur" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>

                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih">
                        </tarihcomp>
                      </v-flex>


                      <v-flex xs12 pt-2 sm6 md3>
                        <v-autocomplete v-model="Rapor.DovizTip" :items="doviztipi" item-text="Title"
                          item-value="DovizKod" :label="$t('Currency-Type')" clearable></v-autocomplete>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout align-center="" fill-height="">
                          <kaydetbutonu :action="getList" :disabled="!load1"
                            color="info" fab small dark :flat="false">
                            <v-icon>search</v-icon>
                          </kaydetbutonu>
                          &nbsp;
                          <v-tooltip bottom>
                            <kaydetbutonu slot="activator" :action="aylikKurGetir" :disabled="!load1"
                              color="teal" fab small dark :flat="false">
                              <v-icon>cloud_download</v-icon>
                            </kaydetbutonu>
                            <span>{{ $t('Fill-Monthly-Rates') }}</span>
                          </v-tooltip>
                          <div v-if="progress">
                            <v-layout>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>

                        </v-layout>
                      </v-flex>
                    </v-layout>


                  </v-card>
                </v-flex>


                <v-layout row wrap>
                  <v-flex pb-1 v-for="item in itemssatis" v-bind:key="item.id" xs12 sm12 md12>
                    <v-hover>
                      <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                        width="100%">
                        <v-card-title>
                          <v-layout row wrap>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-card flat class="black--text">
                                  <v-card flat="">
                                    <v-card-actions>
                                      <v-layout row wrap>

                                        <v-flex xs6 sm2 md2>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <v-icon color="red">assessment</v-icon> &nbsp;
                                            <span class="title black--text font-weight-regular">
                                              {{item.Tarih | dateformat}}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs6 sm1 md1>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="title red--text font-weight-">
                                              {{item.Para}}</span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm2 md2>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight grey--text caption ">
                                                      <v-icon small color="grey">assessment</v-icon>&nbsp; {{ $t('Effective-Buying') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight green--text title ">
                                                      {{item.EfektifAlis | currencyformat}}
                                                    </div>
                                                  </v-list-tile-sub-title>


                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm2 md2>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight grey--text caption ">
                                                      <v-icon small color="grey">assessment</v-icon>&nbsp; {{ $t('Effective-Sales') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight green--text title ">
                                                      {{item.EfektifSatis | currencyformat}}
                                                    </div>
                                                  </v-list-tile-sub-title>


                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm2 md2>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight grey--text caption ">
                                                      <v-icon small color="grey">assessment</v-icon>&nbsp;
                                                      {{$t('Buying') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight green--text title ">
                                                      {{item.Alis | currencyformat}}
                                                    </div>
                                                  </v-list-tile-sub-title>


                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm2 md2>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight grey--text caption ">
                                                      <v-icon small color="grey">assessment</v-icon>&nbsp;
                                                      {{ $t('Sales') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight green--text title ">
                                                      {{item.Satis | currencyformat}}
                                                    </div>
                                                  </v-list-tile-sub-title>


                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>


                                        <v-flex>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-thin">


                                              <v-tooltip bottom>
                                                <v-icon medium="" slot="activator" :disabled="!sayfayetki.Update"
                                                  @click="duzenle(item)" color="green">edit</v-icon>
                                                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                                <span v-if="sayfayetki.Update">{{ $t('Edit') }} </span>
                                              </v-tooltip>

                                            </span>
                                          </v-layout>
                                        </v-flex>

                                      </v-layout>
                                    </v-card-actions>
                                  </v-card>
                                </v-card>
                              </v-flex>
                            </v-layout>

                          </v-layout>
                        </v-card-title>
                      </v-card>
                    </v-hover>
                  </v-flex>
                </v-layout>

              </v-layout>
            </v-form>
          </v-container>



          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>


          <v-dialog v-model="kurekledialog" persistent="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{$t('Exchange-Entry')}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <dovizinput v-model="kur.EfektifAlis" :etiket="$t('Effective-Purchase-Price')"
                          :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput v-model="kur.EfektifSatis" :etiket="$t('Effective-Sales-Price')"
                          :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput v-model="kur.Alis" :etiket="$t('Purchase-Price')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput v-model="kur.Satis" :etiket="$t('Sales-Amount-v2')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="kurekledialog=false">{{$t("cancel_button")}}</v-btn>
                <v-tooltip bottom>
                  <kaydetbutonu slot="activator" :action="kurKaydet"
                    :disabled="!sayfayetki.Update" color="info">
                   {{ $t('Update') }}
                  </kaydetbutonu>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue"
  import tool from "@/components/app/coper/tools"




  export default {

    data() {
      return {



        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        doviztipi: [],
        kurekledialog: false,
        duzenlenenindex: -1,
        progress: false,

        kur: {
          Ref: null,
          Tarih: null,
          Para: null,
          Kur: 0,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          SirketNo: null,
          Alis: 0,
          Satis: 0,
          EfektifAlis: 0,
          EfektifSatis: 0,
        },







        Rapor: {
          BaslangicTarih: null,
          BitisTarih: null,
          DovizTip: null,
        },

        valid: true,


        load1: true,


        itemssatis: [],

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },

    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }

        tool.api_post(this, 'currency/List', params3).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.snackbar = true
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      currencyformat: function (t) {
        return helpers.currencyformat(t);
      }
    },

    components: {
      'tarihcomp': tarihcomp,
      dovizinput,
      yetkidialog,
      kaydetbutonu

    },
    watch: {

    },
    methods: {
      /**
       * Ekrandaki tarihten itibaren 1 aylik kurlari API'ye doldurtur.
       * kaydetbutonu :action prop'u Promise DONDURMESINI sart kosuyor;
       * istek bitene kadar buton pasif kalsin diye zincir donduruluyor.
       */
      aylikKurGetir() {

        if (this.$refs.formkur.validate() === false) {
          return Promise.resolve()
        }

        var params = {
          BaslangicTarih: this.Rapor.BaslangicTarih
        }

        // tool.api_post kullaniliyor: Authorization'in yani sira
        // CariSirketNo / CoperSirketNo / MuhasebeSirketNo basliklarini da
        // gonderiyor. API tarafi aktif sirketi YALNIZCA bu basliklardan
        // okuyor (JWT sirket numarasi tasimiyor); duz $http.post ile
        // CariSirket 0 gidiyor ve sirket parametreleri bulunamiyordu.
        return tool.api_post(this, 'Definitions/WebRateMonthFill', params).then((response) => {

          var cevap = response.body || {}

          // Mesaj istemcide kuruluyor: API'nin ResponseMessage'i sabit Turkce,
          // sayilar cevapta ayri alanlar olarak geliyor. Yalnizca dogrulama
          // hatasinda (ToplamGun = 0) sunucu mesaji gosteriliyor.
          if (cevap.Status === true) {
            this.text1 = this.$t('Monthly-Rates-Filled', { value: cevap.IslenenGun })
          } else if (cevap.ToplamGun > 0) {
            this.text1 = this.$t('Monthly-Rates-Partial', {
              value: cevap.IslenenGun,
              total: cevap.ToplamGun,
              error: cevap.HataliGun
            })
          } else {
            this.text1 = cevap.ResponseMessage
          }
          this.snackbar = true

          // Yeni yazilan kurlar listede gorunsun. Zincir donduruluyor ki
          // buton liste yenilenene kadar pasif kalsin.
          if (cevap.ToplamGun > 0) {
            return this.getList()
          }

        }, (response) => {
          this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.snackbar = true
        })

      },
      kurKaydet() {

        this.kur.Kur=this.kur.Satis
        this.itemssatis.splice(this.duzenlenenindex, 1, this.kur)

        var params = this.itemssatis


        return tool.api_post(this, 'Definitions/WebRateSave', params).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true
          if (response.body.Status === true) {
            this.kurekledialog = false
          }


        }, (response) => {
          this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.progress = false
          this.snackbar = true
        })





      },
      duzenle(val) {


        var a= {
           Ref: val.Ref,
          Tarih: val.Tarih,
          Para: val.Para,
          Kur: val.Kur,
          CreatedBy: val.CreatedBy,
          CreatedDate: val.CreatedDate,
          ModifiedBy: val.ModifiedBy,
          ModifiedDate: val.ModifiedDate,
          SirketNo: val.SirketNo,
          Alis: val.Alis,
          Satis: val.Satis,
          EfektifAlis: val.EfektifAlis,
          EfektifSatis: val.EfektifSatis,
        }

        this.kur = a

        this.duzenlenenindex = this.itemssatis.indexOf(val)
        this.kurekledialog = true

      },

      getList: getList,

    }

  }


  function getList() {

    if (this.$refs.formkur.validate()) {




      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


      var aa = {

        SirketKodu: credentials.SirketKodu,
        BaslangicTarih: this.Rapor.BaslangicTarih,
        BitisTarih: null,
        DovizTip: this.Rapor.DovizTip

      }

      return tool.api_post(this, 'Definitions/WebRateList', aa).then((response) => {
 

        this.itemssatis = response.body



        this.progress = false
        this.load1 = true

      }, (response) => {
        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
        this.snackbar = true
        this.progress = false
        this.load1 = true
      })

    }
  }

</script>
<style>
</style>